"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var DocumentPage_1 = __importDefault(require("./DocumentPage"));
var types_1 = require("../types");
var FOCUSABLE_ELEMENT_TYPES = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
var useStyles = styles_1.makeStyles({
    root: {
        '& *': {
            boxSizing: 'border-box',
        },
    },
    zoomContainer: {
        height: 'fit-content',
    },
    contentContainer: {
        width: '100%',
        padding: '1%',
    },
    spacer: {
        paddingTop: '1%',
    },
});
var focusElement = function (el) {
    var focusableElement = el.matches(FOCUSABLE_ELEMENT_TYPES)
        ? el
        : el.querySelector(FOCUSABLE_ELEMENT_TYPES);
    if (!focusableElement)
        return;
    focusableElement.focus({ preventScroll: true });
};
var DocumentPane = function (_a) {
    var actor = _a.actor, className = _a.className, isAutosignActive = _a.isAutosignActive, onChangeInput = _a.onChangeInput, onDoubleClick = _a.onDoubleClick, onFocusInput = _a.onFocusInput, onNeedPage = _a.onNeedPage, onPageLoadError = _a.onPageLoadError, pageHeight = _a.pageHeight, pages = _a.pages, pageWidth = _a.pageWidth, scrollContainer = _a.scrollContainer, selectedInputId = _a.selectedInputId, zoom = _a.zoom;
    var classes = useStyles();
    var _b = react_1.useState(0), currentPageIndex = _b[0], setCurrentPageIndex = _b[1];
    // We do not need the first value returned from useState here because we are
    // only using the callback form of the setter.
    var setRequestedPageIndexes = react_1.useState([])[1];
    react_1.useEffect(function () {
        pages.forEach(function (page, pageIndex) {
            if (page.imageUrl)
                return;
            var distanceToPage = Math.abs(pageIndex - currentPageIndex);
            if (distanceToPage > 2)
                return;
            setRequestedPageIndexes(function (requestedPageIndexes) {
                if (requestedPageIndexes.includes(pageIndex))
                    return requestedPageIndexes;
                onNeedPage(pageIndex);
                return requestedPageIndexes.concat(pageIndex);
            });
        });
    }, [pages, currentPageIndex]);
    react_1.useEffect(function () {
        if (!selectedInputId)
            return;
        var el = document.getElementById("input-" + selectedInputId);
        if (!el)
            return;
        el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
        });
        focusElement(el);
    }, [selectedInputId]);
    if (pages.length === 0)
        return react_1.default.createElement("div", null, "...");
    var getInputAfter = function (inputId) {
        var allInputs = pages
            .flatMap(function (_a) {
            var inputs = _a.inputs;
            return inputs;
        })
            .filter(function (x) { return !!x; });
        var inputIndex = allInputs.findIndex(function (_a) {
            var id = _a.id;
            return id === inputId;
        });
        return allInputs[inputIndex + 1];
    };
    var handleReachingInputMaxLength = function (inputId) {
        var nextInput = getInputAfter(inputId);
        if (!nextInput)
            return;
        var isNextInputText = nextInput.kind === types_1.PageInputKind.Number ||
            nextInput.kind === types_1.PageInputKind.Text;
        if (!isNextInputText)
            return;
        onFocusInput && onFocusInput(nextInput.id);
    };
    return (react_1.default.createElement("div", { className: clsx_1.default(classes.root, className), onDoubleClick: onDoubleClick },
        react_1.default.createElement("div", { className: classes.zoomContainer, style: { width: zoom * 100 + "%" } },
            react_1.default.createElement("div", { className: classes.contentContainer }, pages.map(function (page, i) { return (react_1.default.createElement(react_1.default.Fragment, { key: i },
                i > 0 && react_1.default.createElement("div", { className: classes.spacer }),
                react_1.default.createElement(DocumentPage_1.default, { actor: actor, "data-tid": "DocumentPane-page-" + (i + 1), isAutosignActive: isAutosignActive, onBecomeCurrent: function () { return setCurrentPageIndex(i); }, onChangeInput: onChangeInput, onFocusInput: onFocusInput, onImageLoadError: function (err, tryCount) {
                        return onPageLoadError(i, err, tryCount);
                    }, onReachInputMaxLength: handleReachingInputMaxLength, page: page, pageHeight: pageHeight, pageWidth: pageWidth, scrollContainer: scrollContainer }))); })))));
};
exports.default = DocumentPane;
//# sourceMappingURL=index.js.map